<script>
import ChallengeApi from '@/services/Api/ChallengeApi'
import ChallengePreview from './ChallengePreview'
import ModalBase from './Modals/ModalBase'

export default {
  components: {
    ChallengePreview,
    ModalBase
  },

  data() {
    return {
      step: 1,
      opened: true,
      loading: false,
      no_challenge: false,
      challenge: null,
      category: '',
      level: ''
    }
  },

  computed: {
    quizz_title() {
      if (this.step === 1) {
        return this.$t('challenges.quizz.cat_title')
      } else if (this.step === 2) {
        return this.$t('challenges.quizz.lvl_title')
      } else if (this.step === 3) {
        return this.$t('challenges.quizz.final_title')
      } else if (this.no_challenge) {
        return this.$t('challenges.quizz.empty_title')
      }
    }
  },

  methods: {
    setCat(cat) {
      this.category = cat
      this.step = 2
    },
    setLevel(lvl) {
      this.level = lvl
      this.step = 3
    },
    getChallenge() {
      this.step = null
      this.loading = true

      ChallengeApi.getChallenges({
        category: this.category,
        level: this.level
      })
      .then(this.chooseChallenge)
      .catch(this.handleError)
      .finally(() => (this.loading = false))
    },
    chooseChallenge(challenges) {
      if (challenges.length) {
        var random = Math.floor(Math.random() * challenges.length)
        this.challenge = challenges[random]
      } else {
        this.no_challenge = true
      }
    },
    handleError(error) {
      this.$emit('close')

      if (error.response.status === 403) {
        this.$store.dispatch('Alerts/add', {
          trans: 'errors.' + error.response.data.error,
          type: 'danger'
        })
      } else {
        this.$handleErrors(error)
      }
    }
  }
}
</script>

<template>
  <modal-base :open="opened" @close="$emit('close')">
    <challenge-preview
      v-if="challenge"
      :challenge="challenge"
      @close="$emit('close')" />

    <section class="modal-card"
      v-else>
      <header class="modal-card-head">
        <h2 class="modal-card-title has-text-centered">
          {{ quizz_title }}
        </h2>
      </header>

      <article class="modal-card-body" v-show="loading">
        <p class="app-simple-loader"></p>
      </article>

      <article class="modal-card-body" v-show="no_challenge">
        <p v-html="$t('challenges.quizz.empty')" v-once></p>
      </article>

      <article class="modal-card-body" v-if="step == 1">
        <button class="button is-warning"
          @click="setCat('DESIGN')">
          {{ $t('challenges.quizz.cat_design') }}
        </button>
        <button class="button is-warning"
          @click="setCat('DEV')">
          {{ $t('challenges.quizz.cat_dev') }}
        </button>
      </article>

      <article class="modal-card-body" v-if="step == 2">
        <button class="button is-warning"
          @click="setLevel(1)">
          {{ $t('challenges.quizz.lvl_easy') }}
        </button>
        <button class="button is-warning"
          @click="setLevel(2)">
          {{ $t('challenges.quizz.lvl_normal') }}
        </button>
        <button class="button is-warning"
          @click="setLevel(3)">
          {{ $t('challenges.quizz.lvl_hard') }}
        </button>
      </article>

      <article class="modal-card-body" v-if="step == 3">
        <button class="button is-warning"
          @click="getChallenge()">
          {{ $t('challenges.quizz.final_1') }}
        </button>
        <button class="button is-warning"
          @click="getChallenge()">
          {{ $t('challenges.quizz.final_2') }}
        </button>
      </article>
    </section>
  </modal-base>
</template>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/all';

.modal-card {
  width: 380px;
  border-radius: $radius;
}

.modal-card-body button {
  display: block;
  width: 100%;
  margin-bottom: pxToEm(10);
}
</style>




// WEBPACK FOOTER //
// ChallengeQuizz.vue?4c378f89